import { PaymentOrder } from "src/models/payment";
import { createEntityModel } from "src/store/models/entity/_shared";

export const PaymentOrderEntityModel = createEntityModel<PaymentOrder>();
